export const CookieKeyMap = {
  TOKEN_KEY: 'KC_AUT',
  LANGUAGE_KEY: 'KC_LANG',
  DISPLAY_LANGUAGE_KEY: 'KC_DISPLAY_LANG',
  QUERY_KEY: 'KC_QUERY',
  CONSOLE_VERSION_KEY: 'KC_VER',
  DESTINATION_KEY: 'destination',
} as const;

export const CookieHeaderKeyMap = {
  SET_COOKIE: 'Set-Cookie',
} as const;
